"use strict";

var PyDefUtils = require("PyDefUtils");

var generateOutlineGuidelines = function(element) {
    var innerTop = element.offset().top + parseFloat(element.css("padding-top"));

    return [
        {x1:element.offset().left, y1: innerTop,
         x2:element.offset().left + element.outerWidth(), y2: innerTop},
        {x1:element.offset().left + element.outerWidth(), y1: innerTop,
         x2:element.offset().left + element.outerWidth(), y2: innerTop + element.height()},
        {x1:element.offset().left, y1: innerTop + element.height(),
         x2:element.offset().left + element.outerWidth(), y2: innerTop + element.height()},
        {x1:element.offset().left, y1: innerTop,
         x2:element.offset().left, y2: innerTop + element.height()},
    ];
}

module.exports = function(pyModule) {

	pyModule["DesignLinearPanel"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {
        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            Sk.misceval.call(pyModule["LinearPanel"].prototype["__init__"], undefined, undefined, kwargs, self);
            
            self._anvil.lpul = $(self._anvil.elements.lpul);

            self._anvil.whereWillItLand = function(x, y, width, height) {
                // "this" is _anvil
                var myChildren = this.lpul.children();

                var childIdx = myChildren.length;
                var suggestedPos = this.lpul.offset().top + this.lpul.height() + parseFloat(this.lpul.css("padding-top"));

                for (var i=0; i<myChildren.length; i++) {
                    if (y + height/2 < $(myChildren[i]).offset().top + $(myChildren[i]).height()/2) {
                        childIdx = i;
                        suggestedPos = $(myChildren[i]).offset().top;
                        break;
                    }
                }

                var guidelines = generateOutlineGuidelines(this.lpul);

                /*
                // This doesn't work - not all children will be the same height!
                // Could position the lines dynamically, but I'm not entirely sure it's worth it.

                var innerTop = this.element.offset().top + parseFloat(this.element.css("padding-top"));
                for (var i = 0; i < myChildren.length; i++) {
                    var y = innerTop + (this.element.height() / myChildren.length) * i;
                    guidelines.push({
                        x1: this.element.offset().left,
                        y1: y,
                        x2: this.element.offset().left + this.element.outerWidth(),
                        y2: y,
                    });
                }
                */

                return {childIdx: childIdx, layoutProperties: {},
                        estimatedPosition: {x: this.lpul.offset().left, y: suggestedPos,
                                            width: this.lpul.outerWidth(), height: 0},
                        guidelines: guidelines,
                        updateProperties: {width: width, height: height}};
            }
        }));


    }, 'DesignLinearPanel', [pyModule["LinearPanel"]]);
};
